import React from "react";
import { MapPin, Mail, Phone, Clock } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function About() {
  const { t, tr, settings } = useApp();
  return (
    <div>
      <div className="relative h-[45vh] bg-neutral-900 overflow-hidden">
        <img src="https://images.unsplash.com/photo-1604840651364-52fe7d985d69?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920" alt="" className="w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <h1 className="brand-font text-white text-4xl md:text-6xl tracking-wide mb-3">{settings.brandName}</h1>
          <p className="text-white/80 text-xs tracking-[0.4em] uppercase">{t("tagline")}</p>
        </div>
      </div>

      <div className="max-w-[820px] mx-auto px-6 py-16 md:py-20 text-center">
        <div className="w-12 h-[2px] mx-auto mb-8" style={{ backgroundColor: "var(--brand)" }} />
        <h2 className="brand-font text-3xl md:text-4xl tracking-wide mb-8">{t("about")}</h2>
        <p className="text-neutral-600 leading-loose font-light text-lg">{tr(settings.aboutText)}</p>
      </div>

      <div className="border-t border-neutral-200 bg-neutral-50">
        <div className="max-w-[1100px] mx-auto px-6 py-16">
          <h2 className="brand-font text-3xl tracking-wide text-center mb-12">{t("contact")}</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              [MapPin, tr(settings.contact.address)],
              [Phone, settings.contact.phone],
              [Mail, settings.contact.email],
              [Clock, tr(settings.contact.hours)],
            ].map(([Ic, val], i) => (
              <div key={i} className="flex flex-col items-center text-center gap-3">
                <Ic size={26} strokeWidth={1.2} style={{ color: "var(--brand)" }} />
                <span className="text-sm text-neutral-600 font-light">{val}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
